

































import { defineComponent, reactive, SetupContext, computed, onMounted, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

interface Data {
  dragAreaText: string
  targetSheetType: number | string
  isApprovalExamFlow: boolean
  errors: string[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      dragAreaText: "",
      targetSheetType: "",
      isApprovalExamFlow: false,
      errors: [],
    });

    /******************************
     * 戻るボタン押下
     ******************************/

    const goBack = (): void => {
      context.root.$router.go(-1);
    };

    /************************************************************
     * テンプレートダウンロード
     ************************************************************/

    const download = async (): Promise<void> => {
      if(state.targetSheetType === ""){
        state.errors = ["試験種別を選択してください。"];
        return;
      }
      window.location.href = `/api/teacher/field_edit/download_field_template/${state.targetSheetType}`;
    };

    /******************************
     * アップロードAPI
     ******************************/

    const upload = async (file: File[]): Promise<void> => {

      if(state.targetSheetType === ""){
        state.errors = ["試験種別を選択してください。"];
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append("sheet_type", String(state.targetSheetType));

      if(!window.confirm("ファイルをアップロードします。\n実行してよろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post("/api/teacher/ikkatsu_field_upload/upload", fd).then(response => {
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 帳票種別に応じたアップロード案内を設定
     ******************************/
    
    const setDragAreaText = () => {
      if(state.targetSheetType == Common.SheetTypeEnum.Report){
        state.dragAreaText = `
          問題構造を記入したエクセルファイルをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。<br>
          ファイル命名規則：rs + QRコード.xlsx　例＞rs220011000101.xlsx
        `
      }else if(state.targetSheetType == Common.SheetTypeEnum.LessonKyouzai){
        state.dragAreaText = `
          問題構造を記入したエクセルファイルをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。<br>
          ファイル命名規則：ks + 講座コード+回次 + (0埋め3桁).xlsx　例＞ksSU0101001.xlsx
        `
      }else if(state.targetSheetType == Common.SheetTypeEnum.LessonTest){
        state.dragAreaText = `
          問題構造を記入したエクセルファイルをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。<br>
          ファイル命名規則：ts + 講座コード+回次 + (0埋め3桁).xlsx　例＞tsSU0101001.xlsx
        `
      }else if(Common.isApprovalExamSheetType(state.targetSheetType)){
        state.dragAreaText = `
          問題構造を記入したエクセルファイルをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。<br>
          ファイル命名規則：ss + QRコード.xlsx　例＞ss220011000101.xlsx
        `
      }else{
        state.dragAreaText = "試験種別を選択してから、ファイルをアップロードしてください。";
      }
    };

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      state.isApprovalExamFlow = Common.isApprovalExamSheetType(context.root.$store.state.sheet_type);
      state.targetSheetType = state.isApprovalExamFlow ? "" : context.root.$store.state.sheet_type;
      setDragAreaText();
    });

    return {
      ...toRefs(state),
      goBack,
      download,
      upload,
      setDragAreaText,
      Common,
    };
  },
})
